webshop.ProductList = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not list view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "List View") {
			this.products_section.addClass("hidden");
		}

		this.products_section.empty();
		this.make();
	}

	make() {
		let me = this;
		let html = `<br><br>`;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 200 ? title.substr(0, 200) + "..." : title;

			html += `<div class='row list-row w-100 mb-4'>`;
			html += me.get_image_html(item, title, me.settings);
			html += me.get_row_body_html(item, title, me.settings);
			html += `</div>`;
		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);

		this.bind_qty_events();
	}

	bind_qty_events() {
		this.products_section.on("input", ".item-qty-area .item-qty", (event) => {
			let currentValue = event.target.value;
			let validValue = currentValue.replace(/[^0-9]/g, "");
			event.target.value = validValue;
		});

		this.products_section.on("click", ".item-qty-area .up-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(currentValue + step);
		});

		this.products_section.on("click", ".item-qty-area .dwn-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let minQty = parseInt(item_qty.data("min-qty")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(Math.max(currentValue - step, minQty));
		});
	}

	get_image_html(item, title, settings) {
		let image = item.website_image;
		let wishlist_enabled = !item.has_variants && settings.enable_wishlist;
		let image_html = ``;

		if (image) {
			image_html += `
				<div class="col-3 list-image">
					<a class="product-link product-list-link" href="/${ item.route || '#' }">
						<img itemprop="image" class="website-image h-100 w-100" alt="${ title }"
							src="${ image }" loading="lazy">
					</a>
					${ wishlist_enabled ? this.get_wishlist_icon(item): '' }
				</div>
			`;
		} else {
			image_html += `
				<div class="col-3 list-image">
					<a class="product-link product-list-link" href="/${ item.route || '#' }"
						style="text-decoration: none">
						<div class="card-img-top no-image-list">
							${ frappe.get_abbr(title) }
						</div>
					</a>
					${ wishlist_enabled ? this.get_wishlist_icon(item): '' }
				</div>
			`;
		}

		return image_html;
	}

	get_row_body_html(item, title, settings) {
		let body_html = `<div class='col-9 text-left'>`;
		body_html += this.get_title_html(item, title, settings);
		body_html += this.get_item_details(item, settings);
		body_html += this.get_cart_action_row(item, settings);
		body_html += `</div>`;
		return body_html;
	}

	get_title_html(item, title, settings) {
		return `
			<div style="display: flex; align-items: center;">
				<div style="flex: 1;">
					<a href="/${ item.route || '#' }"
						style="color: var(--gray-800); font-weight: 600; text-decoration: none;">
						${ title }
					</a>
				</div>
			</div>
		`;
	}

	get_item_details(item, settings) {
		let details = `
			<div class="product-category" itemprop="name">
				${ item.item_group_display || item.item_group }
			</div>
			<p class="product-code">
				${ __('Item Code') } : ${ item.item_code }
			</p>
			<div class="mt-2" style="color: var(--gray-600) !important; font-size: 13px;">
				${ item.short_description || '' }
			</div>
			<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
				${ item.formatted_price || '' }
		`;

		if (item.formatted_mrp) {
			details += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
				<small class="ml-1 product-info-green">
					${ item.discount } ${ __("OFF") }
				</small>
			`;
		}

		details += this.get_stock_availability(item, settings);
		details += `</div>`;

		return details;
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<br>
					<span class="out-of-stock mt-2" style="color: var(--primary-color)">
						${ __("Available on backorder") }
					</span>
				`;
			} else if (!item.in_stock) {
				return `
					<br>
					<span class="out-of-stock mt-2">${ __("Out of stock") }</span>
				`;
			} else if (item.is_stock) {
				return `
					<br>
					<span class="in-stock in-green has-stock mt-2"
						style="font-size: 14px;">${ __("In stock") }</span>
				`;
			}
		}
		return ``;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "wished" : "not-wished";

		return `
			<div class="like-action-list ${ item.wished ? "like-action-wished" : ''}"
				data-item-code="${ item.item_code }">
				<svg class="icon sm">
					<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
				</svg>
			</div>
		`;
	}

	get_cart_action_row(item, settings) {
		if (item.has_variants) {
			return `
				<div class="mt-3">
					<a href="/${ item.route || '#' }">
						<div class="btn btn-sm btn-explore-variants btn-cart-action">
							${ __("Explore") }
						</div>
					</a>
				</div>
			`;
		}

		if (!settings.enabled || (!settings.allow_items_not_in_stock && !item.in_stock)) {
			return ``;
		}

		let cart_badge = '';
		if (item.in_cart) {
			cart_badge = `
				<a href="/cart" class="cart-indicator-link">
					<span class="cart-indicator-badge" data-item-code="${ item.item_code }">
						${ item.in_cart_qty } ${ __("in cart") }
					</span>
				</a>
			`;
		} else {
			cart_badge = `
				<span class="cart-indicator-badge hidden" data-item-code="${ item.item_code }"></span>
			`;
		}

		return `
			<div class="cart-action-row mt-3">
				${ cart_badge }
				<div class="item-qty-area">
					<div class="input-group number-spinner">
						<span class="input-group-prepend d-sm-inline-block">
							<button class="item-qty-btn dwn-qty" data-dir="dwn">
								&ndash;
							</button>
						</span>
						<input class="form-control text-center item-qty"
							value="${ item.min_qty || 1 }"
							min="${ item.min_qty || 1 }"
							step="${ item.lot_size || 1 }"
							data-item-code="${ item.item_code }"
							data-min-qty="${ item.min_qty || 1 }"
							data-lot-size="${ item.lot_size || 1 }">
						<span class="input-group-append d-sm-inline-block">
							<button class="item-qty-btn up-qty" data-dir="up">
								+
							</button>
						</span>
					</div>
				</div>
				<div id="${ item.name }" class="btn btn-sm btn-primary btn-add-to-cart-list"
					data-item-code="${ item.item_code }">
					<svg class="icon icon-md">
						<use href="#icon-assets"></use>
					</svg>
					${ settings.enable_checkout ? __("Add to Cart") : __("Add to Quote") }
				</div>
			</div>
		`;
	}
};
